import { useLocationContext } from 'contexts/LocationContext';
import { useSnowplow } from 'contexts/SnowplowContext';
import { useEffect, useState } from 'react';
import {
  EntityType,
  yleContextGenerator,
  activeEntityContextGenerator,
} from 'services/snowplowAnalytics/contextGenerators';
import { trackPageView } from 'services/snowplowAnalytics/snowplowAnalytics';
import { useUILanguage } from './useUILanguage';
import { Analytics } from '@yleisradio/areena-types';
import { useTunnusContext } from 'contexts/TunnusContext/TunnusContext';
import { useCookieConsent } from 'contexts/CookieConsentContext';

export function useTrackSnowplowPageView(
  analytics: Analytics | undefined
): void {
  const { isSnowplowReady } = useSnowplow();
  const { country_code: countryCode } = useLocationContext() || {};
  const consent = useCookieConsent();
  const { user: { transientId } = {}, isLoggedIn: isAuthenticated } =
    useTunnusContext();
  const language = useUILanguage();
  const ylePageloadAnalytics = analytics?.pageload?.yle;
  const [consentInitialized, setConsentInitialized] = useState(false);

  useEffect(() => {
    if (window?.yleConsentSdk?.initialized) {
      setConsentInitialized(true);
    }
  }, [consent]);

  useEffect(() => {
    if (
      isSnowplowReady &&
      countryCode &&
      ylePageloadAnalytics &&
      consentInitialized
    ) {
      const section = ylePageloadAnalytics['areena_view_type'] || 'page';
      const yleContext = yleContextGenerator({
        countryCode,
        language,
        section,
      });
      const activeEntity = activeEntityContextGenerator(
        ylePageloadAnalytics.entity_type as EntityType,
        ylePageloadAnalytics.id,
        ylePageloadAnalytics.version
      );

      trackPageView(yleContext, activeEntity);
    }
  }, [
    isSnowplowReady,
    countryCode,
    ylePageloadAnalytics,
    language,
    consentInitialized,
    consent,
    isAuthenticated,
    transientId,
  ]);
}
